import * as React from "react";
import { createPortal } from "../../windowManager/browserFenster/fensterPortal";
import { OrdnerNavigator, ordnerTitel } from "./OrdnerNavigator";

/**
 * „Verschieben nach…" — Zielordner in der Kundenakte wählen. Eigenes Popup im
 * kvp-rd-Stil (kein Browser-Dialog). Der geöffnete Ordner ist das Ziel.
 */
export const OrdnerWaehlenDialog: React.FC<{
    contactId: number;
    titel: string;
    /** Ordner, in dem der Dialog startet ("" = Wurzel). */
    startPfad: string;
    /** Ordner, die als Ziel ausscheiden (der verschobene Ordner und alles darunter). */
    ausblenden?: (pfad: string) => boolean;
    bestaetigen?: string;
    onClose: () => void;
    onWahl: (pfad: string) => void;
}> = ({ contactId, titel, startPfad, ausblenden, bestaetigen = "Hierhin verschieben", onClose, onWahl }) => {
    const [pfad, setPfad] = React.useState(startPfad);
    return createPortal(
        <div
            role="dialog"
            aria-modal="true"
            aria-label={titel}
            onClick={onClose}
            onKeyDown={(e) => e.key === "Escape" && onClose()}
            style={{ position: "fixed", inset: 0, zIndex: 100000, background: "rgba(20,8,20,0.34)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
        >
            <div
                className="kvp-rd"
                onClick={(e) => e.stopPropagation()}
                style={{ width: "min(480px, 100%)", background: "#fff", border: "1px solid #ece7f0", borderRadius: 14, boxShadow: "0 24px 64px rgba(20,8,20,0.28)", fontFamily: "'Barlow', 'Segoe UI', sans-serif", padding: 18 }}
            >
                <div style={{ fontWeight: 800, color: "#241522", fontSize: 17, fontFamily: "'Playfair Display', Georgia, serif", overflowWrap: "anywhere", marginBottom: 12 }}>
                    {titel}
                </div>
                <OrdnerNavigator contactId={contactId} pfad={pfad} onPfad={setPfad} neuAnlegen ausblenden={ausblenden} maxHoehe={280} />
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
                    <button type="button" onClick={onClose} style={{ border: "1px solid #ece7f0", background: "#fff", color: "#241522", borderRadius: 10, padding: "8px 14px", fontSize: 13.5, cursor: "pointer", fontFamily: "inherit" }}>
                        Abbrechen
                    </button>
                    <button
                        type="button"
                        autoFocus
                        onClick={() => onWahl(pfad)}
                        style={{ border: "1px solid #4d2051", background: "#4d2051", color: "#fff", borderRadius: 10, padding: "8px 14px", fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}
                    >
                        {bestaetigen} („{ordnerTitel(pfad)}“)
                    </button>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default OrdnerWaehlenDialog;
